import { getBlocksData } from '@zillow/cms-blocks';

/**
 * Processes blocks data from a container (footer, sidebar, etc.)
 * @param container - The container object that has a blocks property
 * @returns Processed blocks data array, or empty array if processing fails
 */
export const processBlocksData = async (
    container: { blocks?: string } | null
) => {
    if (!container) return [];
    try {
        return await getBlocksData(JSON.parse(container.blocks || '[]'));
    } catch (error) {
        console.error('Error processing blocks:', error);
        return [];
    }
};
